<template>
  <div>
    <div class="for-bottom-padding"></div>
    <div id="footer">
      <div class="container">
        <div class="row">
          <div class="large-4 medium-4 columns foot-about">
            <div class="links">
              <h4 class="dark-title"><a href="about.html">关于我们</a></h4>
              <div class="f-about">
                福州市百步园艺有限公司，专注于室内园艺领域，以 “营造绿色办公环境，提升空间生态品质” 为使命。公司拥有 15 年行业经验，致力于为各类办公及商业空间提供专业的绿化解决方案。凭借对福州本地气候的精准把握和对植物生长特性的深入了解，我们能够为客户打造健康、美观且充满活力的室内绿色空间。
              </div>
            </div>
          </div>
          <div class="large-2 medium-2 columns foot-nav">
            <div class="links">
              <h4>友情链接</h4>
              <ul>
                <li><a target="_blank" href="http://ylj.fuzhou.gov.cn/"><i class="fa fa-caret-right"></i> &nbsp;福州市园林中心</a></li>
                <li><a target="_blank" href="http://www.miaomuzhan.com/"><i class="fa fa-caret-right"></i> &nbsp;苗木站</a></li>
                <li><a target="_blank" href="http://www.312green.com/"><i class="fa fa-caret-right"></i> &nbsp;苗青青</a></li>
                <li><a target="_blank" href="http://www.yuanlin365.com/"><i class="fa fa-caret-right"></i> &nbsp;365园林网</a></li>
                <li><a target="_blank" href="https://www.597mm.com/"><i class="fa fa-caret-right"></i> 597苗木网</a></li>
                <li><a target="_blank" href="https://www.miaomu.com/"><i class="fa fa-caret-right"></i> &nbsp;中国苗木网</a></li>
              </ul>
            </div>
          </div>
          <div class="large-3 medium-3 columns foot-contact">
            <h4 class="dark-title"><a href="a/lianxiwomen/index.html">联系我们</a></h4>
            <div class="f-contact"> <i class="fa fa-map-marker"></i> &nbsp;地址：福建省福州市晋安区岳峰镇鹤林村铁路花木基地14号店<br>
              <i class="fa fa-phone"></i> &nbsp;电话：13763897561（周先生）、13615037157（鲍先生）<br>
              <i class="fa fa-home"></i> &nbsp;网址：www.baibuzb.com<br>
              <i class="fa fa-envelope"></i> &nbsp;QQ邮箱：517939059@qq.com<br>
            </div>
          </div>
          <div class="large-3 medium-3 columns foot-qrcode">
            <h4>扫描二维码</h4>
            <div class="f-qrcode"> <img style="width:130px;" src="/skin/images/qrcode.png"> </div>
          </div>
        </div>
      </div>
    </div>
    <section id="footer-bottom">
      <div class="container">
        <div class="row">
          <p> Copyright &copy; 2016-2023 福州市百步园艺有限公司 All Rights Reserved. 备案号：<a style="color: #F5F5F5;" target="_blank"
                                                                                               href="https://beian.miit.gov.cn">闽ICP备15017562号</a>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'FooterMenu',
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
